module.exports = __webpack_public_path__ + "static/media/space-bg-1.274cd586.png";